<!--
 - Author : wanghongling.
 - Date   : 2020/12/30.
 - File   : chinaMap.中国地图
 -->

<template>
  <div class="china-map">
    <transition name="slide-right-fade">
      <div>
        <div v-if="concreteFlag">
          <div class="point-item" style="top: 390px; left: 670px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">2</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 680px; left: 930px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">3</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 300px; left: 1300px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">1</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 415px; left: 1120px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">2</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 550px; left: 910px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">3</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 590px; left: 1100px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">3</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 600px; left: 1050px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">2</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
          <div class="point-item" style="top: 700px; left: 1150px;">
            <div :style="{
             position: 'absolute',
             top: 300 ,
             left: 600
           }">
              <div class="collect">
                <div class="collect-circle">1</div>
                <img src="./images/pos.png" alt="">
              </div>
              <img class="point-light" src="./images/pointLightUp.png">
              <img class="point-light-bg" src="./images/pointLightUp.png">
            </div>
          </div>
        </div>

        <!--中国、省、市地图 点位-->
        <div class="point-item"
             v-for="item in pointList"
             :key="item[keyId]"
             :style="{
             top: item.position.top || 0,
             left: item.position.left || 0
           }"
             @click="$emit('change', item[keyId])"
        >
          <div :style="{
             position: 'absolute',
             top: item.collectPosition.top || 0,
             left: item.collectPosition.left || 0
           }">
            <div class="collect">
              <div class="collect-circle">{{ item.count }}</div>
              <img src="./images/pos.png" alt="">
            </div>
            <img class="point-light" src="./images/pointLightUp.png">
            <img class="point-light-bg" src="./images/pointLightUp.png">
          </div>
          <img class="hide-class" :src="item.background" alt="">
        </div>
      </div>
    </transition>
    <transition name="slide-left1-fade">
      <!--中国、省、市地图视频背景-->
      <video class="video" :src="videoSrc" muted autoplay loop></video>
    </transition>
  </div>
</template>

<script>
import provinceArray from '../../../static/mapPoint/cityPoint/province'
import cityArray from '../../../static/mapPoint/cityPoint'
import mapVideos from '../../../static/mapVideos'

export default {
  name: 'chinaMap',
  data() {
    return {
      // 用于临时展示
      concreteFlag: false
    }
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    countryId: {
      type: String,
      default: ''
    },
    provinceId: {
      type: String,
      default: ''
    },
    orgId:{
      type: String,
      default: ''
    },
    isShowChina:{
      type: Boolean,
      default: false
    }
  },
  watch:{
    orgId:{
      handler(newOrgId) {
        if(this.isShowChina && newOrgId==='2990C1E9616F41FF81140C25615ABC00'){
          this.concreteFlag = true
        }
        else {
          this.concreteFlag = false
        }
      },
      immediate: true
    },
    isShowChina:{
      handler(newchinaMsg) {
        if(newchinaMsg && this.orgId==='2990C1E9616F41FF81140C25615ABC00'){
          this.concreteFlag = true
        }
        else {
          this.concreteFlag = false
        }
      },
      immediate: true
    }
  },
  computed: {
    // 判断返回的是省id还是市id
    keyId() {
      if (this.countryId) return 'provinceId'
      if (this.provinceId) return 'cityId'
    },
    // 判断返回地图轮廓视频
    videoSrc() {
      if (this.countryId) return mapVideos[this.countryId]
      if (this.provinceId) return mapVideos[this.provinceId]
    },
    /**
     * 点位列表
     * @author: dawangf(dawangf@sina.com)
     * @createDate: 2021/1/20
     * @return {[]}
     */
    pointList() {
      console.log('pointList:', this.list)
      let tmp = []
      if (this.countryId) {
        this.list.forEach(value => {
          if (provinceArray[value.provinceId]) {
            tmp.push({...value, ...provinceArray[value.provinceId]})
          }
        })
      }
      if (this.provinceId) {
        console.log('cityArray:', cityArray[this.provinceId])
        const tmpArr = cityArray[this.provinceId]
        this.list.forEach(value => {
          if (tmpArr[value.cityId]) {
            tmp.push({...value, ...tmpArr[value.cityId]})
          }
        })
      }
      return tmp
    }
  }
}
</script>

<style lang="less" scoped>
.china-map {

  .point-item {
    position: absolute;
    z-index: 12;
    cursor: pointer;

    .point-light {
      position: absolute;
      z-index: 4;
      right: -80px;
      top: -75px;
      animation: rotateLight 1.5s linear infinite;
    }

    .point-light-bg {
      position: absolute;
      z-index: 4;
      right: -80px;
      top: -75px;
      opacity: 0.6;
    }
  }


  .hide-class {
    animation: showHide 1s linear alternate infinite;
  }

  /*聚合*/

  .collect {
    position: absolute;
    top: -25px;
    left: -15px;
    cursor: pointer;
    z-index: 5;
    animation: trianglePop 1.5s infinite;

    img {
      position: absolute;
      left: 2px;
      top: 25px;
      z-index: -1;
    }

    &-circle {
      width: 26px;
      height: 26px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: #fff;
      border: 1px solid #b66655;
      background-color: #f2813b;
      background-image: linear-gradient(#f2813b, #e95227);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mapIndex/chinaMap.vue